/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clean_Gross_Termite_WinInputs */

const fr_clean_gross_termite_win = /** @type {(inputs: Clean_Gross_Termite_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la mise à jour de l'email`)
};

/**

* @param {Clean_Gross_Termite_WinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const clean_gross_termite_win = /** @type {((inputs?: Clean_Gross_Termite_WinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clean_Gross_Termite_WinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_clean_gross_termite_win(inputs)
});